import { ExportTransportTypes } from 'constants/exportTypes';
import { NotificationTypes } from 'constants/notifications';

import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import qs from 'qs';
import { Notification } from 'types/embedded/notification';

export type NotificationsRequestParams = {
  createdAt: {
    gte: number;
    lte: number;
  };
  'transports.transport': ExportTransportTypes;
  notificationType: NotificationTypes[];
};
export type NotificationsResponse = Notification[];

export const getNotifications = async (
  filter: NotificationsRequestParams,
): Promise<NotificationsResponse> => {
  const params = qs.stringify(
    {
      ...filter,
    },
    { arrayFormat: 'indices', encode: true },
  );
  return axios
    .get(`notifications?${params}`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const updateNotificationsViewedStatus = async (ids?: string[]): Promise<AxiosResponse> => {
  return axios
    .patch('notifications/is_viewed', { ids })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.message));
};

export const updateNotificationsDownloadedStatus = async (id?: string): Promise<AxiosResponse> => {
  return axios
    .patch(`notifications/${id}/is_download`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.message));
};

export type NotificationsCountRequestParams = {
  createdAtFrom: number;
  createdAtTo: number;
  transport: ExportTransportTypes;
  isViewed: number;
};
export type NotificationsCountResponse = { count: string };

export const getNotificationsCount = async (
  filter: NotificationsCountRequestParams,
): Promise<NotificationsCountResponse> => {
  const params = qs.stringify(
    {
      ...filter,
    },
    { arrayFormat: 'indices', encode: true, allowDots: true },
  );
  return axios
    .get(`notifications/count?${params}`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};
